import { Field as VeeField } from 'vee-validate';
import { Component, Vue } from 'vue-facing-decorator';
import { buildValidationResult } from '@/ui/helpers/build-validation';

@Component({
  components: {
    VeeField,
  },
})
export class ValidationMixin extends Vue {
  readonly buildValidationResult = buildValidationResult;
}
